import { useState, useEffect } from 'react';
import { checkImageLoads } from '../utils/general';

interface ImageState {
  isValidUrl: boolean;
  imgUrl: string;
}

interface UseImageValidatorOptions {
  imageUrls: (string | undefined | null)[];
  dependencies?: any[];
}

export const useImageValidator = ({
  imageUrls,
  dependencies = []
}: UseImageValidatorOptions) => {
  const [imageState, setImageState] = useState<ImageState>({
    isValidUrl: false,
    imgUrl: '',
  });

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const validateImages = async () => {
      setIsLoading(true);

      // Filter out null/undefined values
      const validUrls = imageUrls.filter((url): url is string => !!url);

      // Try each URL in order
      for (const url of validUrls) {
        if (await checkImageLoads(url)) {
          setImageState({
            isValidUrl: true,
            imgUrl: url,
          });
          setIsLoading(false);
          return;
        }
      }

      // No valid images found
      setImageState({
        isValidUrl: false,
        imgUrl: '',
      });
      setIsLoading(false);
    };

    validateImages();
  }, [...dependencies]);

  return { ...imageState, isLoading };
};